<template>
    <div class="col-md-12 px-0 py-0 mt-5">
        <form class="form-horizontal">
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Jurado</label
                >
                <div class="col-md-9">
                    <multiselect
                        v-model="judge"
                        placeholder="Seleccione jurado"
                        label="name"
                        track-by="id"
                        :options="arrayJudges"
                        :disabled="disableJudge"
                    ></multiselect>
                    <span v-if="allerrors.user_id" :class="['show-error']">{{
                        allerrors.user_id[0]
                    }}</span>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label" for="text-input"
                    >Categorias</label
                >
                <div class="col-md-9">
                    <multiselect
                        v-model="categories"
                        placeholder="Seleccione categorias"
                        label="name"
                        track-by="id"
                        :options="arrayCategories"
                        :multiple="true"
                        :taggable="true"
                    ></multiselect>
                    <span v-if="allerrors.categories" :class="['show-error']">{{
                        allerrors.categories[0]
                    }}</span>
                </div>
            </div>

            <div class="modal-footer">
                <button
                    v-if="model_id == 0"
                    type="button"
                    @click="create()"
                    class="btn btn-primary"
                >
                    Agregar
                </button>
                <button
                    v-if="model_id > 0"
                    type="button"
                    @click="update()"
                    class="btn btn-primary"
                >
                    Actualizar
                </button>
            </div>
        </form>
    </div>
</template>
<script>
import { _ } from "vue-underscore";
export default {
    props: {
        model_id: Number,
        parent_id: Number,
    },
    data() {
        return {
            action: "",
            judge: null,
            categories: [],
            arrayCategories: [],
            arrayJudges: [],
            allerrors: [],
            disableJudge: false,
        };
    },
    methods: {
        getModel() {
            let me = this;
            axios
                .get("/api/contests/judges/show/" + me.model_id)
                .then(function (response) {
                    me.judge = response.data.user;
                    me.categories = response.data.categories;
                })
                .catch(function (error) {});
        },
        getListContestCategories() {
            let me = this;
            axios
                .get("/api/contests/categories/select-input?contest_id=" + me.parent_id)
                .then(function (response) {
                    me.arrayCategories = response.data;
                })
                .catch(function (error) {});
        },
        getListJudges() {
            let me = this;
            axios
                .get("/api/judges?paginate=false")
                .then(function (response) {
                    me.arrayJudges = response.data;
                })
                .catch(function (error) {});
        },
        create() {
            let me = this;
            axios
                .post(me.action, {
                    user_id: me.judge ? me.judge.id : null,
                    categories: _.pluck(me.categories, "id"),
                })
                .then(function (response) {
                    me.allerrors = [];
                    me.showActionSuccess("Creacion exitosa!");
                    me.$emit("change");
                })
                .catch(function (error) {
                    if (error.response && error.response.data) {
                        me.allerrors = error.response.data.errors;
                    }
                });
        },
        update() {
            let me = this;
            axios
                .put(me.action, {
                    categories: _.pluck(me.categories, "id"),
                    contest_id: me.parent_id,
                })
                .then(function (response) {
                    me.allerrors = [];
                    me.showActionSuccess("Actualizacion exitosa!");
                })
                .catch(function (error) {
                    if (error.response && error.response.data) {
                        me.allerrors = error.response.data.errors;
                    }
                });
        },
        showActionSuccess(message) {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: message,
            });
        },
    },
    mounted() {
        let me = this;
        const authUserId = document.querySelector(
            'meta[name="x-user"]'
        ).content;
        me.getListContestCategories();
        me.getListJudges();
        if (me.model_id == 0) {
            me.action = `/api/contests/judges?contest_id=${me.parent_id}&key=${authUserId}`;
            me.disableJudge = false;
        } else {
            this.getModel();
            me.action = "/api/contests/judges/update/" + me.model_id;
            me.disableJudge = true;
        }
    },
};
</script>
<style>
.show-error {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #f86c6b;
}
</style>
